__turbopack_context__.v({
  "actions": "EditInsolePair-module__MHYdqW__actions",
  "container": "EditInsolePair-module__MHYdqW__container",
});
